import React, { Component } from 'react';
import { Link } from '@sunrun/component-library';
import PropTypes from 'prop-types';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorMessage: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // If there was a loading chunk error it could be that the version
    // they requested doesn't exist on the server anymore, so lets reload the app
    if (error.message && error.message.startsWith('Loading chunk')) {
      window.location.reload();
      return;
    }

    try {
      // Defined globally at window scope in main app index.js
      window.Rollbar.error('Error Boundary Crash', error);
      window.Rollbar.error(error, { context: 'Error Boundary Hit' });
    } catch (err) {
      // localstorage has been disabled
      // eslint-disable-next-line max-len
      this.setState({
        errorMessage: (
          <>
            Your browser settings are preventing mySunrun from loading properly. Try another browser or{' '}
            <Link href="mailto:customercare@sunrun.com">contact Customer Care</Link> for assistance.
          </>
        ),
      });
    }
  }

  render() {
    const { children, render } = this.props;
    const { hasError, errorMessage } = this.state;
    if (hasError) {
      return render(errorMessage);
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  render: PropTypes.func.isRequired,
};

export default ErrorBoundary;
